<template>

  <div style="position: relative;">

    <div class="answerCard resultat_card" v-if="!showBP">
      <div>
        <span class="pageNumber pull-left">{{index+1}} / {{questionCount}}</span>
        <span class="questionScore pull-right badLabel" v-if="!isGood">{{$t('front_end.result_recap_bad')}}</span>
        <span class="questionScore pull-right goodLabel" v-if="isGood">{{$t('front_end.result_recap_good')}}</span>
      </div>
      <div class="clearfix"></div>
      <p class="pt-3 questionText"><b>{{question.question | translategrader($i18n.locale)}}</b></p>
      <div class="userAnswers">
        <p v-for="answer in question.userAnswer" :class="{goodColor: isGood, badColor:!isGood}"><i class="fa fa-arrow-circle-right pr-2"></i></i>&#171;&nbsp;{{answer | translategrader($i18n.locale)}}&nbsp;&#187;</p>
      </div>
    </div>

    <div class="answerCard best_practice" v-if="showBP">
      <div class="bp_title"><h2><span>{{$t('front_end.best_practice')}}</span></h2></div>
      <div v-html="addSmartFrenchQuotes($options.filters.translategrader(question.resultat_texte, $i18n.locale))" :style="fitCard($options.filters.translategrader(question.resultat_texte, $i18n.locale))">

      </div>
    </div>

  </div>

</template>


<script>


export default {
  name: 'answerCardPrint',

  props: ['question', 'index', 'questionCount', 'isPrint', 'showBP'],

  data () {
    return {
      // showBP: false,
      // isPrint: false
    }
  },

  mounted: function(){
    // console.log(this.question);
  },

  computed: {

    isGood: function() {
      return (false ||  (this.question.userScore/this.question.maxScore)> 0.66);
    },
    isMedium: function() {
      return (false ||
              (
               (this.question.userScore/this.question.maxScore)<= 0.66
               &&
               (this.question.userScore/this.question.maxScore)>0.33
              )
             );
    },
    isBad: function() {
      return (false ||  (this.question.userScore/this.question.maxScore)<= 0.33);
    },
  },

  methods: {

    addSmartFrenchQuotes(a) {

        a = a.replace(/(\&nbsp;| |^)"(\w)/g, "$1\u00AB\&nbsp;$2"); // opening doubles
        a = a.replace(/(\w|\.|\?|\!)"(\w| |\&nbsp;|\.)/g, "$1\&nbsp;\u00BB$2");                            // closing doubles
        return a;
      },

    addSmartFrenchQuotesOld(a) {
        // Add Smart Quotes, French style
        // See https://leancrew.com/all-this/2010/11/smart-quotes-in-javascript/
        a = a.replace(/(^|[-\u2014\s(\["])'/g, "$1\u2018");       // opening singles
        a = a.replace(/'/g, "\u2019");                            // closing singles & apostrophes
        a = a.replace(/(^|[-\u2014/\[(\u2018\s])"/g, "$1\u00AB\&nbsp;"); // opening doubles
        a = a.replace(/"/g, "\&nbsp;\u00BB");                            // closing doubles
        a = a.replace(/--/g, "\u2014");                           // em-dashes
        return a
      },

    fitCard(textInput) {
      // console.log(answer);
      var charCount = textInput.length;
      var fontSize = "14px";
      if (charCount > 650) {
        fontSize = "13px"
      };
      if (charCount > 900) {
        fontSize = "13px"
      };

      return {
        fontSize: fontSize
      }
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.answerCard{
  position: relative;
  background-color: #fff;
  margin: 10px;
  border-radius: 9px;
  border: 1px solid #C0C6CD;
  padding: 20px;
  height: 350px;
  width: calc(100% - 20px);
  overflow: hidden;
  page-break-inside: avoid!important;
}

.resultat_card {
  background-color: #fff;
  color: #000;
}

.best_practice {
  background-color: #fff;
  color: #404040;
}

.questionScore {
  color: #fff;
  border-radius: 11px;
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  padding: 2px 7px;
}

.questionText {
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
}
.userAnswers {
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  max-width: 80%
}

.goodLabel {
  background-color: #139A43;
}

.badLabel {
  background-color: #DC0000;
}
.goodColor {
  color: #139A43;
}

.badColor {
  color: #DC0000;
}

.bp_title {
  text-transform: uppercase;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 30px;
}
.bp_title h2 {
  /* See https://stackoverflow.com/a/5214204/2550237 */
  width:100%;
  text-align:center;
  border-bottom: 5px solid #404040;
  line-height:0.01em;
  margin:10px 0 20px;
}

.bp_title h2 span {
  background: #fff;
  padding:0 10px;
}

.infoTip {
  position: absolute;
  bottom: 0px;
  right: 0px;
  background-color: #404040;
  color: #fff;
  width: 40px;
  height: 40px;
  padding: 10px;
  padding-left: 15px;
  border-top-left-radius: 9px;
  cursor: pointer;
}

.infoTip:hover {
  background-color: #333;
}

</style>



// WEBPACK FOOTER //
// src/components/survey_results/answerCardPrint.vue